import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type HotelPricingManagerBulkUpdateRoute from 'lumen/routes/hotel/pricing-manager/bulk-update';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelPricingManagerBulkUpdateController extends Controller {
  declare model: ModelFrom<HotelPricingManagerBulkUpdateRoute>;
  queryParams = ['bulkStartDate', 'bulkEndDate'];

  @service declare router: Services['router'];

  @tracked bulkEndDate: string | null = null;
  @tracked bulkStartDate: string | null = null;

  @action closeModal(): void {
    this.router.transitionTo('hotel.pricing-manager');
  }

  @action updateQueryParams(
    startDate: string | null,
    endDate: string | null,
  ): void {
    this.bulkStartDate = startDate;
    this.bulkEndDate = endDate;
  }
}
